import FiliationPicker from './filiationPicker/Component'
import CollectionPicker from './collectionPicker/Component'
import PersonPicker from './personPicker/Component'
import ProductPicker from './productPicker/Component'
import ProductItemPicker from './productItemPicker/Component'

export default {
  install(Vue) {
    Vue.component('filiation-picker', FiliationPicker)
    Vue.component('collection-picker', CollectionPicker)
    Vue.component('person-picker', PersonPicker)
    Vue.component('product-picker', ProductPicker)
    Vue.component('product-item-picker', ProductItemPicker)
  },
}
